<template>
  <div class="toolset">
    <form class="searcher mt-3" @submit.prevent="searcher">
      <InputText
        v-model="search"
        class="mr-2 text-sm font-light w-10"
        placeholder="Buscar"
      />
      <Button
        class="text-sm font-light"
        type="submit"
        icon="pi pi-search"
        severity="secondary"
      />
    </form>
    <div>
      <slot></slot>
      <Button
        v-if="isAdding"
        class="text-sm font-light mt-2"
        :label="addButtonLabel"
        :icon="addButtonIcon"
        @click="toAdd"
      />
    </div>
  </div>
</template>

<script lang="ts" setup>
  import { ref } from 'vue'

  const search = ref('')

  interface ToolsetProps {
    isAdding?: boolean
    addButtonLabel?: string
    addButtonIcon?: string
    searcher: () => void
    toAdd?: () => void
  }

  const props = withDefaults(defineProps<ToolsetProps>(), {
    isAdding: true,
    addButtonLabel: 'Agregar',
    addButtonIcon: 'pi pi-plus',
    searcher: () => {},
    toAdd: () => {},
  })

  defineExpose({
    search,
  })
</script>

<style scoped>
  .toolset {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    justify-content: space-between;
    width: 90%;
  }

  .searcher {
    font-size: 14px;
    width: 300px;
    display: flex;
    flex-flow: row nowrap;
    justify-content: space-between;
  }
</style>
